import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import './AppShell.css';

export interface SidebarGroupProps {
  labelKey: string;
  /** When true, the textual label is hidden (used in 56px tablet icon-rail). */
  collapsed?: boolean;
  children: ReactNode;
}

const SidebarGroup: React.FC<SidebarGroupProps> = ({ labelKey, collapsed, children }) => {
  const { t } = useTranslation();
  return (
    <div className={`shell-sidebar-group${collapsed ? ' shell-sidebar-group--collapsed' : ''}`}>
      {!collapsed && <div className="shell-sidebar-group__label">{t(labelKey)}</div>}
      <div className="shell-sidebar-group__items">{children}</div>
    </div>
  );
};

export default SidebarGroup;
